module.exports = __webpack_public_path__ + "img/idcard_front.4e5d7532.png";